import { createStore } from 'vuex';
import ccfsf from './modules/ccfsf';

export default createStore({
    modules: {
        ccfsf
    }
});
